import * as Application from "expo-application";
import { View } from "react-native";
import { BodyText } from "~/components/layout/text";
import { Items } from "~/constants/layout";
import { filled } from "~/util";

export const AppVersion = () => {
    return (
        <View style={[Items.center]}>
            <BodyText size="xs" colour="tertiary" align="center">
                Version: {Application.nativeApplicationVersion ?? "development"}
                {filled(Application.nativeBuildVersion) && `.${Application.nativeBuildVersion}`}
            </BodyText>
        </View>
    );
};
